// import * as Sentry from '@sentry/nextjs';

// // if (process.env.NODE_ENV === 'production') {
// if (process.env.NODE_ENV !== 'development') {
//   Sentry.init({
//     dsn: `${process.env.NEXT_PUBLIC_SENTRY_DSN}`,

//     // Adds request headers and IP for users, for more info visit:
//     // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
//     sendDefaultPii: true,

//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for tracing.
//     // We recommend adjusting this value in production
//     // Learn more at
//     // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
//     tracesSampleRate: 1.0,
//     integrations: [
//       // Replay may only be enabled for the client-side
//       Sentry.replayIntegration(),
//       Sentry.feedbackIntegration({
//         // Additional SDK configuration goes in here, for example:
//         colorScheme: 'system',
//       }),
//     ],

//     // Capture Replay for 10% of all sessions,
//     // plus for 100% of sessions with an error
//     // Learn more at
//     // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,

//     // Enable logs to be sent to Sentry
//     enableLogs: true,

//     // Note: if you want to override the automatic release value, do not set a
//     // `release` value here - use the environment variable `SENTRY_RELEASE`, so
//     // that it will also get attached to your source maps
//   });
// }

// // This export will instrument router navigations, and is only relevant if you enable tracing.
// // `captureRouterTransitionStart` is available from SDK version 9.12.0 onwards
// export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
